export function register() {
  // PWA/service worker desactivado a propósito.
  // Mantenerlo como no-op evita que código viejo vuelva a registrar caché.
  return Promise.resolve();
}

export function unregister() {
  try {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          try {
            registration.unregister();
          } catch (e) {}
        });
      });
    }

    if (typeof window !== 'undefined' && 'caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          try {
            caches.delete(name);
          } catch (e) {}
        });
      });
    }
  } catch (e) {}
}
